import React from "react";
import { Link } from "react-router-dom";
import Card from "../../../components/ui-components/Card";
import Badge from "../../../components/ui-components/Badge";
import { statusLabel, statusTone, formatVariance } from "../status";

const money = (value) => {
  if (value == null) return "—";
  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(value);
};

// Metric is one headline figure. Numbers stay out of prose and on their own
// line so the row scans as a strip.
function Metric({ label, value, hint }) {
  return (
    <div className="flex-1 min-w-[140px]">
      <div className="text-text-2 text-xs uppercase">{label}</div>
      <div className="text-2xl">{value}</div>
      {hint ? <div className="text-text-2 text-xs">{hint}</div> : null}
    </div>
  );
}

export default function OverviewTab({ useCase }) {
  const row = useCase?.row ?? {};
  const budget = row.budget ?? null;

  return (
    <div className="flex flex-col gap-4">
      <Card>
        <div className="flex flex-wrap gap-6 p-4">
          <Metric label="Spend this period" value={money(row.rolledCost)} />
          <Metric label="Budget" value={budget ? money(budget.capEur) : "—"} />
          <Metric label="Forecast" value={money(row.forecast)} />
          <Metric label="Variance" value={formatVariance(row.variance)} />
          <div className="flex-1 min-w-[140px]">
            <div className="text-text-2 text-xs uppercase">Status</div>
            <Badge status={statusTone(row.status)} label={statusLabel(row.status)} />
          </div>
        </div>
      </Card>

      <Card>
        <div className="p-4">
          <div className="text-text-2 text-xs uppercase mb-2">Budget</div>
          {budget ? (
            <Link to={`/budgets/${budget.budgetId}`} className="underline">
              {budget.budgetName}
            </Link>
          ) : (
            <div className="flex flex-col gap-1">
              <div>No budget covers this use case.</div>
              {/* No prefill: /budgets/new does not read any query parameters
                  (BudgetCockpitPage has no useSearchParams / location.search
                  read), so a scoped link here would be dead and misleading. */}
              <Link to="/budgets/new" className="underline">
                Create budget
              </Link>
            </div>
          )}
        </div>
      </Card>

      <Card>
        <div className="p-4">
          <div className="text-text-2 text-xs uppercase mb-2">Economic value</div>
          <div>Not measured.</div>
          <div className="text-text-2 text-sm">
            Measuring value needs an outcome, a unit value and a baseline for this
            use case. See the Value &amp; ROI tab.
          </div>
        </div>
      </Card>
    </div>
  );
}
